import { render, staticRenderFns } from "./HistoryTab.vue?vue&type=template&id=567fd684&scoped=true"
import script from "./HistoryTab.vue?vue&type=script&lang=js"
export * from "./HistoryTab.vue?vue&type=script&lang=js"
import style0 from "./HistoryTab.vue?vue&type=style&index=0&id=567fd684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567fd684",
  null
  
)

export default component.exports